import {clx, ControlledAutocompleteSelectOption, Pill, TextSemiBold} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {REPORT_FILTERS_WIDGET_NAMESPACE} from '../consts'

interface PillsFilterProps {
  name: string
  title: string
  options: ControlledAutocompleteSelectOption[]
  selectedValues: (string | number)[]
  onChange: (values: (string | number)[]) => void
  displayTitle?: boolean
  hideAllOption?: boolean
}
export const PillsFilter = ({
  name,
  options,
  title,
  onChange,
  selectedValues,
  displayTitle = false,
  hideAllOption = false
}: PillsFilterProps) => {
  const {t} = useTranslation(REPORT_FILTERS_WIDGET_NAMESPACE)
  const isAllSelected = selectedValues.length === options.length

  const isPillSelected = (value: string | number) =>
    selectedValues.includes(value) && !isAllSelected

  const togglePillSelection = (value: string | number) => {
    if (isAllSelected) {
      onChange([value])
      return
    }
    if (isPillSelected(value)) {
      onChange(selectedValues.filter((v) => v !== value))
    } else {
      onChange([...selectedValues, value])
    }
  }

  const allOptions = options.flatMap((option) => option.value)

  return (
    <div className={clx(displayTitle ? 'flex flex-col gap-2' : '')}>
      {displayTitle && <TextSemiBold>{title}</TextSemiBold>}
      <div className="flex flex-wrap gap-2">
        {!hideAllOption && (
          <Pill
            key={`all-${name}`}
            text={t('filterOptions.all')}
            type={isAllSelected ? 'primary' : 'neutral'}
            size="regular"
            variant="shade"
            className="mr-2"
            onClick={() => onChange(isAllSelected ? [] : allOptions)}
            data-cy={`${name}_filter_pill_all`}
          />
        )}
        {options.map((option) => (
          <Pill
            key={`${option.value}-${name}`}
            text={option.label}
            type={isPillSelected(option.value) ? 'primary' : 'neutral'}
            size="regular"
            variant="shade"
            className="mr-2"
            onClick={() => togglePillSelection(option.value)}
            data-cy={`${name}_filter_pill_${option.value}`}
          />
        ))}
      </div>
    </div>
  )
}
